export const Gallery__Images = [
    {
        id: 1,
        src: require('../img/Home - Unlabeled Elite Ent.png').default,
        alt: 'image',
        Header:'Unlabeled Elite Ent'
    },
    {
        id: 2,
        src: 'https://images.unsplash.com/photo-1499854413229-6d1c92ff39ef?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1102&q=80',
        alt: 'silverstonergv.com',
        Header:'silverstonergv'
    },
    {
        id: 3,
        src: 'https://images.unsplash.com/photo-1509114397022-ed747cca3f65?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=675&q=80',
        alt: 'Greenstoneservices.com',
        Header:'greenstone services'
    },
    {
        id: 4,
        src: require('../img/inProgress.webp').default,
        alt: 'image',
        Header:'in Progress'
    },
    {
        id: 5,
        src: require('../img/inProgress.webp').default,
        alt: 'image',
        Header:'in Progress'
    },
    {
        id: 6,
        src: require('../img/inProgress.webp').default,
        alt: 'image',
        Header:'in Progress'
    },
    {
        id: 7,
        src: require('../img/inProgress.webp').default,
        alt: 'image',
        Header:'in Progress'
    },
    {
        id: 8,
        src: require('../img/inProgress.webp').default,
        alt: 'image',
        Header:'in Progress'
    },
    {
        id: 9,
        src: require('../img/inProgress.webp').default,
        alt: 'image',
        Header:'in Progress'
    },
    {
        id: 10,
        src: require('../img/inProgress.webp').default,
        alt: 'image',
        Header:'in Progress'
    }
]